export default "__VITE_ASSET__DjaSaa0A__"